import { ROLE_ADMIN, ROLE_MANAGER, ROLE_INVENTORY } from '@/utils/roles'

export default {
  computed: {
    user() {
      return this.$page.props.auth.user
    },

    userInitials() {
      let initials = ''

      if (!this.user) {
        return initials
      }

      if (this.user.first_name) {
        initials += this.user.first_name.charAt(0).toUpperCase()
      }

      if (this.user.last_name) {
        initials += this.user.last_name.charAt(0).toUpperCase()
      }

      return initials
    },

    firstName() {
      let first_name = ''

      if (!this.user) {
        return first_name
      }

      if (this.user.first_name) {
        first_name = this.user.first_name
      }

      return first_name
    },

    lastName() {
      let last_name = ''

      if (!this.user) {
        return last_name
      }

      if (this.user.last_name) {
        last_name = this.user.last_name
      }

      return last_name
    },

    email() {
      let email = ''

      if (!this.user) {
        return email
      }

      email = this.user.email

      return email
    },

    systemRole() {
      return this.user ? this.user.system_role : null
    },

    company() {
      return this.$page.props.auth.company
    },

    companyRole() {
      return this.$page.props.auth.company_role
    },

    permissions() {
      return this.$page.props.auth.company_permissions
    },

    locations() {
      return this.$page.props.auth.locations.data
    },

    currentLocation() {
      return this.$page.props.auth.current_location ? this.$page.props.auth.current_location.data : null
    },

    currentLocationId() {
      return this.currentLocation ? this.currentLocation.id : null
    },

    isAdmin() {
      return this.systemRole === ROLE_ADMIN
    },

    isCompanyAdmin() {
      return this.companyRole && this.companyRole === ROLE_ADMIN
    },

    isCompanyManager() {
      return this.companyRole && this.companyRole === ROLE_MANAGER
    },

    isCompanyInventory() {
      return this.companyRole && this.companyRole === ROLE_INVENTORY
    },

    isCompanyAdminOrManager() {
      return this.isCompanyAdmin || this.isCompanyManager
    }
  },
  methods: {
    /*
        Accepts a string or array of strings. Returns true if the user has any of the given permissions.
         */
    hasPermission(permission) {
      if (typeof permission === 'string') {
        permission = [permission]
      }

      if (typeof permission === 'object' && Array.isArray(permission)) {
        return this.permissions.filter((item) => permission.findIndex((i) => i === item) >= 0).length > 0
      }

      return false
    }
  }
}
